import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bce7236"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base text-content py-3" }
const _hoisted_2 = { class: "flex justify-center" }

import { ref, watch, onMounted } from 'vue'
import moment from 'moment-timezone'
import { COACH_ATTEND_MINUTE } from '@/data/room'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'CoachAbsentPopup',
  props: {
  isAttend: {
    type: Boolean,
    default: false,
  },
  startTime: {
    type: [String, Date],
    default: '',
  },
  exitPath: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const isOpen = ref(false)
const { t } = useI18n()

const close = () => {
  isOpen.value = false
}

const confirm = () => {
  close()
  if (props.exitPath) {
    window.location.href = props.exitPath
  }
}

/**
 * Check class time after 10 min when coach attend is show coach absent popup
 */
const checkTime = (start: moment.Moment) => {
  const currentTime = moment()
  const isBetween = currentTime.isSameOrAfter(start)
  return isBetween
}

const countdown = () => {
  /**
   * if coach attend do nothing
   */
  if (props.isAttend) return
  const timeAbsent = moment(props.startTime).add(COACH_ATTEND_MINUTE.ABSENT, 'minute')
  const isBefore = moment().isBefore(timeAbsent)
  /**
   * if student attend before time of coach absent
   * isBefore is true and countdown to show message
   */
  if (isBefore) {
    /**
     * if student attend before time of coach absent
     * ex. classtime 10.00 timeAbsent -> 10.10
     */
    const setCountdown = setInterval(() => {
      if (checkTime(timeAbsent)) {
        isOpen.value = !props.isAttend
      }
      if (isOpen.value) {
        clearInterval(setCountdown)
      }
    }, 1000)
  } else {
    isOpen.value = true
  }
}

watch(
  () => props.isAttend,
  () => {
    if (props.isAttend) {
      close()
    }
  },
)

onMounted(() => {
  countdown()
})

return (_ctx: any,_cache: any) => {
  const _component_Popup = _resolveComponent("Popup")!

  return (__props.startTime)
    ? (_openBlock(), _createBlock(_component_Popup, {
        key: 0,
        title: _unref(t)('coach-attend.absent.title'),
        open: isOpen.value,
        onClose: close
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary text-white text-base w-full ml-2",
              onClick: confirm
            }, _toDisplayString(_ctx.$t('coach-attend.absent.confirm')), 1)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('coach-attend.absent.content')), 1)
        ]),
        _: 1
      }, 8, ["title", "open"]))
    : _createCommentVNode("", true)
}
}

})